import React from 'react';
import { motion } from 'framer-motion';
import './Music.css';


export default function Music() {
  return (
    <motion.main
      className="music-page"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -14 }}
      transition={{ duration: 0.25 }}
    >
      <section className="music-hero">
        <video
          className="music-hero-video"
          src="https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/0511.mp4"
          autoPlay
          muted
          loop
          playsInline
        />
        <div className="music-hero-overlay" />
        <div className="music-scanlines" />
        <div className="container music-hero-content">
          <h1 className="music-hero-title">
            <span className="title-line">KICK.</span>
            <span className="title-line title-accent">ZAAG.</span>
            <span className="title-line">MICROWAVE.</span>
          </h1>
          <p className="music-subtitle">
            Donders veel, zaag, Magnatron en meer. Zodra ik de oortjes aan heb geniet heel het kantoor mee.
            Buren zijn op de hoogte gesteld. Ze zijn verhuisd.
          </p>
        </div>
      </section>

      <div className="music-stats-bar">
        <div className="container music-stats-inner">
            <div className="music-stat">
              <span className="music-stat-value">180+</span>
              <span className="music-stat-label">BPM MINIMAAL!</span>
            </div>
            <div className="music-stat">
              <span className="music-stat-value">2</span>
              <span className="music-stat-label">Zeurende buren</span>
            </div>
            <div className="music-stat">
              <span className="music-stat-value">10</span>
              <span className="music-stat-label">Jaar tot ik doof ben</span>
            </div>
            <div className="music-stat">
              <span className="music-stat-value">100%</span>
              <span className="music-stat-label">Kickrolls geraakt</span>
            </div>
        </div>
      </div>

      <section className="music-section">
        <div className="container">
          <div className="music-intro-card">
            <div className="music-intro-left">
              <span className="music-intro-tag">Wat ik luster</span>
              <h2>Sommige volk noemt het wat geluid<br />maar dit zijn de dikste ploatn</h2>
            </div>
            <p className="music-intro-desc">
              Hardstyle, rawstyle, uptempo als het je bureau niet laat trillen staat het niet hard genoeg.
              Codeer sessie draaien op 180 BPM en veel te veel chocolade melk
            </p>
          </div>

          <article className="music-card music-card-single">
            <div className="music-card-top">
              <div className="music-card-label">
                <span className="music-genre">Mijn speellijstje</span>
              </div>
              <h2>DONDERS HAKKUUH</h2>
              <p className="music-note">Geniet donders met, Magnatron, Zaag en alles. Ge-nie-ten</p>
            </div>
            <div className="music-embed-wrap">
              <iframe
                title="DONDERS HAKKUUH"
                src="https://open.spotify.com/embed/playlist/3Y9Ep2A0u9DOm81h3MdX47?utm_source=generator" 
                width="100%"
                height="352"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              />
            </div>
          </article>

          <p className="music-footer-note">
            Op vol volume luisteren is geen keuze
          </p>
        </div>
      </section>
    </motion.main>
  );
}
